var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError403(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 804 804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "m4kg3ypd1a",
    x1: -158.05,
    y1: 1994.64,
    x2: -158.05,
    y2: 1992.22,
    gradientTransform: "matrix(93.51, 0, 0, -187.61, 14976.78, 374459.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03a7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600dc"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25-2",
    cx: 403.37,
    cy: 403.84,
    r: 399.59,
    style: {
      fill: "#dcdede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,486.46A220.57,220.57,0,0,0,303,412.38c93.06-78,105.24-216.73,27.21-309.79q-1.89-2.27-3.84-4.47a227,227,0,0,0-61.74-49.19C239.46,61.82,214.35,74.85,187,82.13V79.62q-7.14,5.17-14.18,10.48a414.38,414.38,0,0,0-67.37,65.2C90.2,175.91,69.56,199.49,59.24,223c-13,31.87-28.23,64.51-33.39,98.54-8.63,30.6-17.18,62.4-13.85,91.2,6.31,42.09,17.19,104.85,33.39,144.14,9.08,21,22.07,52.12,26.88,58.64,18.73,25.24,34.87,36.82,47.24,55.37s29.86,21.91,43.16,39.91c6.85,9.26,27.35,12.13,33.93,21.6.9,1.29,1.76,2.59,2.62,3.89l1.63,1.16c26.44,9.09,53.28,17.49,76.57,32.45C372.62,711.45,410.13,589.35,360.75,486.46Z",
    style: {
      fill: "url(#m4kg3ypd1a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 237",
    d: "M152,103.43c-1.56,0-3.12,0-4.67.09a33.13,33.13,0,0,1-10,8.87A316.13,316.13,0,0,0,93.74,158a351.07,351.07,0,0,0-27.52,42.34c-4.37,8-8.38,16.16-12.78,24.14-3.77,6.81-7.33,13.72-10.59,20.79a233,233,0,0,0-10.23,39.16c-.81,4.46-1.74,8.95-2.87,13.35A135.61,135.61,0,1,0,152,103.43Z",
    style: {
      fill: "#fbfbfb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "logo-n-circle2",
    cx: 152.67,
    cy: 270.3,
    rx: 45.04,
    ry: 44.19,
    style: {
      fill: "#1d1d1b"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 518",
    style: {
      opacity: 0.9980000257492065
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 247",
    d: "M403.43,4C183.71,4,5.59,182.13,5.59,401.85S183.72,799.69,403.45,799.69,801.28,621.57,801.28,401.85,623.15,4,403.43,4Zm0,99.46c164.52-.27,298.12,132.88,298.39,297.4a297.9,297.9,0,0,1-55.46,173.61L230.81,158.92A296.5,296.5,0,0,1,403.43,103.46ZM105.05,401.85A296.39,296.39,0,0,1,160.5,229.23L576.06,644.77h0c-133.9,95.61-319.94,64.58-415.55-69.31A297.87,297.87,0,0,1,105.05,401.85Z",
    style: {
      fill: "red"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M402,804A402.11,402.11,0,0,1,245.52,31.59a402.11,402.11,0,0,1,313,740.82A399.54,399.54,0,0,1,402,804ZM402,8A394.11,394.11,0,0,0,248.64,765,394.1,394.1,0,0,0,555.36,39,391.59,391.59,0,0,0,402,8Z",
    style: {
      fill: "#1253fa"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError403);
export default __webpack_public_path__ + "static/media/error-403.a40283fd.svg";
export { ForwardRef as ReactComponent };